import {
  CREATE_IN_APP_NOTIFICATION,
  DELETE_IN_APP_NOTIFICATION
} from "../../store/constants/inAppNotifications";

const initialState = {
  data: []
};

export default function(state = initialState, action) {
  switch (action.type) {
    case CREATE_IN_APP_NOTIFICATION:
      const pushExist = state.data.find(
        item => item.id === action.notification.id
      );

      if (pushExist !== undefined) {
        return state;
      } else {
        return {
          ...state,
          data: [...state.data, constructInAppNotification(action.notification)]
        };
      }

    case DELETE_IN_APP_NOTIFICATION:
      return {
        ...state,
        data: state.data.filter(item => item.id !== action.id)
      };
    default:
      return state;
  }
}

const constructInAppNotification = notification => {
  return {
    id: notification.id,
    title: notification.title,
    text: notification.text,
    link: notification.link,
    datetime: Date.now()
  };
};
